var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { BooleanField, DatagridConfigurable, List, ReferenceField, ReferenceManyField, TextField, TextInput, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { ChipList } from "../../components/ChipList";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
var OMIT_FIELDS = ["id", "is_consolidated_ballot_encoding", "spoil_ballot_option"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Description", source: "description" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Election Event ID", source: "election_event_id" }, 3),
];
export var ListElection = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h5" }, { children: "Elections" })), _jsx(List, __assign({ actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), filter: { tenant_id: tenantId || undefined }, aside: aside, filters: Filters }, { children: _jsxs(DatagridConfigurable, __assign({ rowClick: rowClickHandler, omit: OMIT_FIELDS }, { children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name" }), _jsx(TextField, { source: "description" }), _jsx(BooleanField, { source: "is_consolidated_ballot_encoding" }), _jsx(BooleanField, { source: "spoil_ballot_option" }), _jsx(ReferenceManyField, __assign({ label: "Contests", reference: "sequent_backend_contest", target: "election_id" }, { children: _jsx(ChipList, { source: "sequent_backend_contest", filterFields: ["election_event_id", "election_id"] }) })), _jsx(ReferenceField, __assign({ source: "election_event_id", reference: "sequent_backend_election_event" }, { children: _jsx(TextField, { source: "name" }) }))] })) }))] }));
};
